import { createSelector } from 'reselect'
import { ConfidenceLevels } from '../../../../constants/confidence-levels'

const submissionApiSelectors = {
    selectVersionById: (arg, result) => ({
        ...result,
        data: result?.data?.find(version => version.id === arg.id),
    }),
}

export const fetchSubmissionReviewsSelectors = {
    isReviewedById: (arg, result) => ({
        ...result,
        data: result?.data?.some(review => review.submissionId === arg.id),
    }),
    isReviewedWithCorrectionsById: (arg, result) => ({
        ...result,
        data: result?.data?.some(
            review =>
                review.submissionId === arg.id &&
                (review.newPatternId !== review.oldPatternId || review.newReasoning !== review.oldReasoning),
        ),
    }),
    reviewsById: (arg, result) => ({
        ...result,
        data: result?.data?.filter(review => review.submissionId === arg.id),
    }),
}

export const fetchNotConfidentSubmissionsSelectors = {
    isNotConfidentById: (arg, result) => ({
        ...result,
        data: result?.data && arg.id in result.data,
    }),
}

const getUnreviewedSubmissions = createSelector([result => result.data || [], (result, arg) => arg], (data, arg) =>
    data.filter(submission => submission.reviewStatus === arg),
)

export const fetchTextAssignmentSubmissionsSelectors = {
    byId: (arg, result) => ({
        ...result,
        data: result?.data?.find(submission => submission.id === arg.id),
    }),
    byReviewStatus: (arg, result) => ({
        ...result,
        data: getUnreviewedSubmissions(result, arg),
    }),
}

export const fetchTextSubmissionDetailsSelectors = {
    feedback: result => ({
        ...result,
        data: result?.data?.feedback || '',
    }),
    answerByQuestionId: (arg, result) => ({
        ...result,
        data: result?.data?.answers?.find(answer => answer.questionId === arg.questionId),
    }),
    answerByQuestionRubricId: (arg, result) => ({
        ...result,
        data: result?.data?.answers?.find(answer => answer.questionRubricId === arg.questionRubricId),
    }),
}

export const fetchSimilarAnswersQuerySelectors = {
    byId: (arg, result) => ({
        ...result,
        data: result?.data?.[arg.id],
    }),
}

export const fetchAnswerCategoryMismatchPredictionsSelectors = {
    byAnswerId: (arg, result) => ({
        ...result,
        data: result?.data?.find(prediction => prediction.answerId === arg.answerId),
    }),
}

export const fetchQuestionAnswersSelectors = {
    numberOfHighConfidenceAnswersPerCategory: (arg, result) => ({
        ...result,
        data: result?.data?.filter(
            answer => answer.categoryId === arg.categoryId && answer.confidence === ConfidenceLevels.VERY_CONFIDENT,
        ).length,
    }),
    numberOfMyHighConfidenceAnswersPerCategory: (arg, result) => ({
        ...result,
        data: result?.data?.filter(
            answer =>
                answer.categoryId === arg.categoryId &&
                answer.reviewerId === arg.userId &&
                answer.confidence === ConfidenceLevels.VERY_CONFIDENT,
        ).length,
    }),
}

export default submissionApiSelectors
